<template>
  <div class="quotation-tags">
    <p class="qt-title">{{ $t('CAMPAIGN_FLOW.QUOTATION.TAGS.TITLE') }}</p>
    <p class="qt-desc">{{ $t('CAMPAIGN_FLOW.QUOTATION.TAGS.DESC') }}</p>
    <div class="qt-list">
      <button
        v-for="tag in tags"
        :key="tag"
        type="button"
        class="qt-chip"
        :title="$t('CAMPAIGN_FLOW.QUOTATION.TAGS.COPY')"
        @click="onCopy(tag)"
      >
        <code>{{ tag }}</code>
        <span>{{ $t(`CAMPAIGN_FLOW.QUOTATION.TAGS.LABELS.${tag}`) }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';
import { copyTextToClipboard } from 'shared/helpers/clipboard';

export default {
  mixins: [alertMixin],
  data() {
    return {
      tags: [
        'cotacao_valor',
        'cotacao_plano',
        'cotacao_placa',
        'cotacao_marca',
        'cotacao_modelo',
        'cotacao_ano',
        'cotacao_valor_fipe',
      ],
    };
  },
  methods: {
    async onCopy(tag) {
      await copyTextToClipboard(tag);
      this.showAlert(this.$t('CAMPAIGN_FLOW.QUOTATION.TAGS.COPIED'));
    },
  },
};
</script>

<style scoped>
.quotation-tags {
  margin: 1.2rem 0;
  padding: 1.2rem 1.4rem;
  border: 1px solid var(--color-border);
  border-radius: 1rem;
  background: var(--s-25);
}
.qt-title {
  margin: 0;
  font-size: 1.3rem;
  font-weight: 700;
  color: var(--color-ink-strong);
}
.qt-desc {
  margin: 0.2rem 0 1rem;
  font-size: 1.2rem;
  color: #8a97a3;
}
.qt-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
}
.qt-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.4rem 0.9rem;
  border: 1px solid var(--color-border);
  border-radius: 20px;
  background: var(--color-surface);
  font-size: 1.15rem;
  color: #516170;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.qt-chip:hover {
  border-color: #0e9f8f;
  box-shadow: 0 1px 2px rgba(16, 32, 45, 0.08);
}
.qt-chip code {
  padding: 0;
  background: transparent;
  border: 0;
  font-weight: 700;
  color: #0e9f8f;
}
:root[data-theme='dark'] .qt-chip,
:root[data-theme='dark'] .qt-desc {
  color: var(--color-body);
}
</style>
